// @flow
import React from "react";
import styled, { css } from "styled-components";
import { useHistory } from "react-router";
import { Field, Form } from "react-final-form";
import { Button } from "@nested/component-library";
import { media } from "@nested/rebrand";

import { AddressPicker, onboardingCtaHandler } from "./AddressPicker";
import { EmailCaptureForm as OriginalEmailCaptureForm } from "./EmailCaptureForm";

const EmailCaptureForm = styled(OriginalEmailCaptureForm)`
  margin: 30px auto 0;

  ${media.desktop`
    margin: 30px 0 0 0;
  `}
`;

const formStyles = css`
  margin: 30px auto 0;
  position: relative;
  width: 100%;
  max-width: 350px;
  ${media.tablet`
    max-width: 348px;
  `}
  ${media.desktop`
    margin: 30px 0 0;
    width: 80%;
    max-width: 354px;
  `}
`;

const inputIllusionBox = css`
  background-color: white;
  border: 1px solid ${({ theme }) => theme.palette.hague40};
  border-top: none;
  border-radius: 0 0 4px 4px;
  padding: 0 10px 10px;
  button {
    width: 100%;
    height: 50px;
    color: ${({ theme }) => theme.palette.hague130};
  }
  button:hover,
  button:disabled:hover {
    background-color: ${({ theme }) => theme.palette.terracotta90};
    color: ${({ theme }) => theme.palette.hague130};
  }
  button:active,
  button:disabled:active {
    background-color: #ff6d56;
    color: ${({ theme }) => theme.palette.hague130};
  }
  button:disabled {
    background-color: ${({ theme }) => theme.palette.terracotta};
    color: ${({ theme }) => theme.palette.hague130};
  }
`;

const required = (value) => (value ? undefined : "Required");

type Props = {
  formType?: "onboarding" | "emailSubscription",
  stateOverride?: any,
  submitButtonText: string,
};

export const HeroForm = ({
  formType,
  stateOverride,
  submitButtonText,
}: Props) => {
  if (formType === "emailSubscription") {
    return <EmailCaptureForm submitButtonText={submitButtonText} />;
  }
  const history = useHistory();
  const onSubmit = onboardingCtaHandler("hero-address-cta", history);
  return (
    <Form
      onSubmit={onSubmit}
      initialValues={{
        "hero-address-cta":
          (stateOverride && stateOverride["hero-address-cta"]) || null,
      }}
    >
      {({ handleSubmit, pristine, submitting, hasValidationErrors }) => (
        <form
          onSubmit={handleSubmit}
          css={formStyles}
          data-test="hero-address-cta-form"
        >
          <Field validate={required} name="hero-address-cta">
            {({ input, meta }) => (
              <AddressPicker
                dataTest="hero-address-cta"
                placeholder="Enter your postcode"
                includeBlacklisted
                includeNotInServicedArea
                hasButtonBelow
                withPin
                stateOverride={
                  stateOverride &&
                  stateOverride["hero-address-cta-stateOverride"]
                }
                {...input}
                {...meta}
              />
            )}
          </Field>
          <div css={inputIllusionBox} className="illusion-box">
            <Button
              disabled={pristine || hasValidationErrors || submitting}
              type="accent"
              data-test="homepage-hero-submit-button"
            >
              {submitButtonText}
            </Button>
          </div>
        </form>
      )}
    </Form>
  );
};
